import styled from "styled-components";

import { useTranslation } from "react-i18next";
import CustomCheckbox from "../../helperComponents/CustomCheckbox";
import CustomButton from "../../helperComponents/CustomButton";
import goTo from "../../../controllers/goTo";
import { useState } from "react";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
  /* justify-content: center; */
  /* align-items: center; */
  flex-wrap: wrap;
  padding: 25px;
`;

const List = styled.div`
  display: flex;
  flex-direction: row;
  gap: 7px;
  /* justify-content: center; */
  /* align-items: center; */
  flex-wrap: wrap;
  padding: 0;
`;

export default function FieldsSelectorPopup({ fieldsList, value, onChange }) {
  const [localValue, setLocalValue] = useState(value);
  const { t } = useTranslation();

  return (
    <Container>
      <List>
        {fieldsList.map((item) => {
          return (
            <CustomCheckbox
              label={t(item)}
              value={localValue.includes(item)}
              onChange={() => {
                if (localValue.includes(item)) {
                  let newValue = [...localValue];
                  let index = newValue.indexOf(item);
                  newValue.splice(index, 1);
                  makeUpdate(newValue);
                } else {
                  let newValue = [...localValue];
                  newValue.push(item);
                  makeUpdate(newValue);
                }
              }}
            />
          );
        })}
      </List>

      <CustomButton style={{ width: "200px" }} onClick={goTo(-1)}>
        Done
      </CustomButton>
      <br />
    </Container>
  );

  function makeUpdate(newValue) {
    onChange(newValue);
    setLocalValue(newValue);
  }
}
